import React from "react";
import { Helmet } from "react-helmet-async";

const BlogSchema = ({ post }) => {
  if (!post) return null;

  const image =
    post.media?.length > 0
      ? `${process.env.REACT_APP_IMAGES_BASE_URL}${post.media[0].path}`
      : "https://www.elgestionador.com/images/default-post.jpg";

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": window.location.href
    },
    "headline": post.title,
    "description": post.meta_description || post.excerpt || post.description || "",
    "image": image,
    "author": {
      "@type": "Person",
      "name": "elgestionador",
      "url": "https://www.elgestionador.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "elgestionador",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.elgestionador.com/images/logo.png"
      }
    },
    "datePublished": post.publication_date,
    "dateModified": post.updated_at || post.publication_date
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default BlogSchema;
